import _ from 'lodash'
import UploadService from '../services/UploadService'
import DocumentServices from '../services/DocumentServices'
import { getMetadatosFiles } from '../services/MetadatosUtils'

export default {
  namespaced: true,
  state: () => ({
    files: [],
    dialogFileBox: false,
    isUploadingFile: false,
    fileHeaders: [
      { text: 'Nombre', value: 'filename', sortable: false, width: '380' },
      {
        text: 'Descripción',
        value: 'description',
        width: '380',
        sortable: false
      },
      { text: ' ', value: 'actions', sortable: false, width: '60' }
    ]
  }),
  mutations: {
    SET_FILES(state, files) {
      state.files = files
    },
    SET_DIALOG_FILE_BOX(state, dialog) {
      state.dialogFileBox = dialog
    },
    SET_IS_UPLOADING_FILE(state, isUploading) {
      state.isUploadingFile = isUploading
    }
  },
  actions: {
    openFileBox({ commit }) {
      commit('SET_DIALOG_FILE_BOX', true)
    },
    closeFileBox({ commit }) {
      commit('SET_DIALOG_FILE_BOX', false)
    },
    setFiles({ commit }, files) {
      let aux = []

      _.forEach(files, f => {
        aux.push({
          filename: f.name,
          description: f.name.substr(0, f.name.lastIndexOf('.')) || f.name,
          fileData: f
        })
      })

      commit('SET_FILES', aux)
    },
    removeFile({ commit, state }, file) {
      let auxFiles = _.filter(state.files, function(f) {
        return f.filename !== file.filename
      })

      commit('SET_FILES', auxFiles)

      if (auxFiles.length === 0) {
        commit('SET_DIALOG_FILE_BOX', false)
      }
    },
    updateFileProperties({ commit, state }, file) {
      let newFiles = _.map(state.files, function(f) {
        return f.filename === file.filename
          ? {
              filename: f.filename,
              description: file.description,
              fileData: f.fileData
            }
          : f
      })

      commit('SET_FILES', newFiles)
    },
    async uploadFiles({ commit, state }) {
      const service = new UploadService()
      const documentServices = new DocumentServices()
      let auxFiles = []

      _.forEach(state.files, f => {
        auxFiles.push(f.fileData)
      })

      try {
        commit('SET_IS_UPLOADING_FILE', true)

        const resp = await service.uploadToS3(auxFiles)
        const respuesta = resp.data

        if (respuesta.success) {
          const uploadedFiles = respuesta.data.documento
          const metaFiles = getMetadatosFiles(state.files, uploadedFiles)

          if (metaFiles.length > 0) {
            for (let index = 0; index < metaFiles.length; index++) {
              const m = metaFiles[index]
              await documentServices.updateDescripcion(m)
            }
          }

          commit('SET_DIALOG_FILE_BOX', false)
          commit('SET_IS_UPLOADING_FILE', false)
          commit('SET_FILES', [])
        }

        return respuesta
      } catch (err) {
        commit('SET_IS_UPLOADING_FILE', false)
        if (err.request.response) {
          const errorData = JSON.parse(err.request.response).error
          return {
            success: false,
            error: errorData
          }
        } else {
          return {
            success: false,
            error: err
          }
        }
      }
    }
  },
  getters: {
    files(state) {
      return state.files
    },
    fileHeaders(state) {
      return state.fileHeaders
    },
    dialogFileBox(state) {
      return state.dialogFileBox
    },
    isUploading(state) {
      return state.isUploadingFile
    }
  }
}
